import createWork from '../../../case/create-work';
import { openAssignment } from '../../../case/open-assignment';
import { openWorkByHandle } from '../../../case/open-work-by-handle';
import { finishAssignment } from '../../../case/finish-assignment';
import { cancelAssignment } from '../../../case/cancel-assignment';
import { navigateToStep } from '../../../case/navigate-to-step';
import deleteCaseInCreateStage from '../../../case/delete-case-in-create-stage';
import saveAndCloseAssignment from '../../../case/save-and-close';
import openLocalAction from '../../../case/open-local-action';
import openBulkAction from '../../../case/open-bulk-action';
import { submitBulkAction } from '../../../case/submit-bulk-action';
import { submitBulkActionAsync } from '../../../case/submit-bulk-action-async';
import openProcessAction from '../../../case/open-process-action';
import { releaseLock } from '../../../case/release-lock';
import { showCreateStageCancelAlert, activateModalContainerItem } from '../../../case/miscellaneous-actions';
import { openEmbeddedDataModal } from '../../../case/open-embedded-data-modal';
import { submitEmbeddedDataModal } from '../../../case/submit-embedded-data-modal';
import { getDescendants } from '../../../case/get-descendants';
import { submitSubscript } from '../../../case/submit-subscript';

const caseEpics = [
  /* opening of work items */
  createWork,
  openAssignment,
  openWorkByHandle,
  openLocalAction,
  openBulkAction,
  submitBulkAction,
  submitBulkActionAsync,
  openProcessAction,

  /* processing on already opened assignments */
  finishAssignment,
  navigateToStep,
  cancelAssignment,

  /* release lock on assignment */
  releaseLock,

  /* create stage related actions */
  saveAndCloseAssignment,
  deleteCaseInCreateStage,
  showCreateStageCancelAlert,

  /* other */
  activateModalContainerItem,
  openEmbeddedDataModal,
  submitEmbeddedDataModal,
  getDescendants,
  submitSubscript
];

export default caseEpics;
